module.exports = __webpack_public_path__ + "img/poor-kid-v1.676536c0.jpg";